// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// LOCAL UI ONLY
// demo.${domain}
// dev.${domain}
//test
const subdomain = 'goveva-brookfieldproperties'
const domain = 'com'

const BasePATH_GFMRootPath = `C:/GEM/GFM`;
const BaseURL_MasterAPI = `https://test-masterapi.goveva.com`;
const BaseURL_PSSAPI = `https://${subdomain}.${domain}`;
const BaseURL_PSSUI = `https://${subdomain}.${domain}`;
const BaseURL_GEMURL = `https://${subdomain}.${domain}/gem`;
const BaseURL_PSSFileurl = `https://${subdomain}.${domain}/complianceapi/`;
const BaseURL_PSSFileNotValidurl = `https://${subdomain}.${domain}/complianceapi`;
//Prod
const WebexUrl = `https://${subdomain}.${domain}/webex/index.html`;
const BaseURL_UIBaseUrl = `https://${subdomain}.${domain}`;
const BaseURL_GovevaAPI = `https://${subdomain}.${domain}`; // Client API
const GovevaApipath = `govevaapi/api/v1/`;
const BaseURL_TranscriptAPI = `https://${subdomain}.${domain}/tapi`;
const webexTranscriptUrl = `https://${subdomain}.${domain}/webex/transcriptIndex.html`;
const webexTranscriptOrigin = `https://${subdomain}.${domain}`;

//Local Frontend
// const WebexUrl = `http://localhost:4200/webex/index.html`;
// const BaseURL_UIBaseUrl = `http://localhost:4200`;
// const BaseURL_GovevaAPI = `https://${subdomain}.${domain}`; // Client API
// const GovevaApipath = `govevaapi/api/v1/`;
// const BaseURL_TranscriptAPI = `https://${subdomain}.${domain}/tapi`; // Client API
// const webexTranscriptUrl= `http://localhost:4200/webex/transcriptIndex.html`;

//Local frontend + backendnpm install @angular/cli@12.2.16 --legacy-peer-depsnpm install @angular/cli@12.2.16 --legacy-peer-deps
// const WebexUrl = `http://localhost:4200/webex/index.html`;
// const BaseURL_UIBaseUrl = `http://localhost:4200`;
// const BaseURL_GovevaAPI = `http://localhost:5000`; // Client API
// const BaseURL_TranscriptAPI = `https://${subdomain}.${domain}/tapi`; // Client API
// const GovevaApipath = `api/v1/`;
// const webexTranscriptUrl= `http://localhost:4200/webex/transcriptIndex.html`;


/*
const BasePATH_GFMRootPath = '/home/ec2-user/GEM/GFM/';
const BaseURL_MasterAPI = 'https://test-masterapi.${domain}.com';
const BaseURL_GovevaAPI = 'https://dev.${domain}.com'; // Client API
const BaseURL_PSSAPI = 'https://dev.${domain}.com';
const BaseURL_PSSUI = 'https://dev.${domain}.com';
const BaseURL_GEMURL = 'https://dev.${domain}.com/gemapi';
const BaseURL_PSSFileurl = 'https://dev.${domain}.com/complianceapi/';
const BaseURL_PSSFileNotValidurl = 'https://dev.${domain}.com/complianceapi';
const WebexUrl = 'http://localhost:4200/assets/html/test.html';
const BaseURL_UIBaseUrl = 'http://localhost:4200';
const GovevaApipath = 'govevaapi/api/v1/';
*/

export const environment = {
  production: false,
  PSS: false,
  TaskMakerChecker: true,
  IsUPSIMakerCheckerUsed: true,
  envName: 'development',
  gemIp_domain: "goveva-brookfieldproperties.com:8085",
  
  LAWS: true, //for Laws&Regulations
  MfaLogin: false,
  goEvaUrl: 'https://master.digicompany.in/api/v1/secure/', //Laws&Regulation URL
  goEvaFileUrl: 'https://master.digicompany.in/',//Laws&Regulation URL
  MeetingMailURL: `${BaseURL_PSSAPI}/#/structure/(structure-outlet:addMeetings/edit/`,
  chatbotURL: `https://robocs.${subdomain}.${domain}`,
  financialExtractURL: `https://financialdata.${subdomain}.${domain}`,
  useFinancialExtractAPI: true,

  FinalMenu: {
    MeetingMasters: true,
    Master: true,
    ESG: false,
    Complaince: true,
    UPSI: false,
    NCD: false,   
    Laws: false,  
    Admin: true,
    File: true,
    Payroll: false
  },
  Service: {
    All: false,
    PSS: true,
    GovEva: true,
    UPSI: false,
    NCD: false,
    BoardEvaluation: false,
    RiskEvaluation: false,
    GEM: true,
    GemWeb: true,
    Chat: false,
    Governance: true,
    RegularMeeting: true,
    MeetingMakerWithAgenda: false,
    MeetingMakerWithoutAgenda: false,
    // GemWeb: false,
    // Governance: true,
    // RegularMeeting: false,
    // MeetingMakerWithAgenda : false,
    // MeetingMakerWithoutAgenda : false,
    CompanySetupWithoutMasterApi: false,
    AdobePdfEmbedKey: "64e0a6bb3ede420581bc3510bf77e9c8", //brookfield
    //AdobePdfEmbedKey: "dd7cd5a34c994147bed266180540a284", //staging
      //AdobePdfEmbedKey: "16156ca590a145f693ca1fb54879be34" //app
    
    //Authorisation key check with the master API
    authorization: 'QmVhcmVyIDcxRDUwRjk5ODc1Mjk=',
  },

  govEvaUIBaseUrl: `https://${subdomain}.${domain}/#/`,
  fileurl: BaseURL_PSSFileNotValidurl,
  url: `${BaseURL_MasterAPI}/api/v1/secure/`,
  clientUrl: `${BaseURL_GovevaAPI}/${GovevaApipath}secure/`,
  nonValidateUrl: `${BaseURL_GovevaAPI}/${GovevaApipath}`,
  pssServerUrl: `${BaseURL_PSSAPI}/complianceapi/api/v1/secure/`,

  companyConfiguredUrl: `${BaseURL_PSSAPI}/govevaapi/api/v1/secure/`,

  pssUIBaseUrl: `${BaseURL_PSSUI}/#/`,
  pssUIBaseUrl1: `${BaseURL_PSSUI}/#/`,
  pssUIURL: `${BaseURL_PSSUI}/#/`,
  serverIP: `${BaseURL_GovevaAPI}/govevaapi/`,
  transcriptURL: `${BaseURL_TranscriptAPI}`,
  GEMURL: `${BaseURL_GEMURL}/api/`,
  GFMRootPath: BasePATH_GFMRootPath,
  sessionTime: 28800000,
  PSSFileurl: BaseURL_PSSFileurl,
  PSSFileNotValidurl: `${BaseURL_PSSFileNotValidurl}/api/v1/`,
  webexUrl: WebexUrl,
  webexTranscriptUrl: webexTranscriptUrl,
  webexTranscriptOrigin: webexTranscriptOrigin,
  UIBaseUrl: BaseURL_UIBaseUrl,
  licenseKey: 'HXjIKysyTGmk_E9s0yB84kosqWfOG3KDtRwhDvGWqA0WWceef6OMtbQ4BVZpsOVfM9oBeMn2TBZ7NJCNY27jpz4tLYxg6wuSMhaopb167uqIBxlsc0xe_UjFm-iKeL6W9kFlkzVqBrqg5CuZk0LSRYrqaiFWf-tY0bjIQCYiSBdTJZtZUf9JA2GOmC4fwxsnMnYugFij3xm9l7v4XE3yuB8-VXSxTcux_hBGIl3yQLDcKJAIdASKfW56b6gUSsF3uhzo0kRmAimUOsGGtqcvxTEOrX8uGYkNMyHTrVY3BgpPRj-ewsqAFvLWcbgbzS3TUl-t2uxuGI1ZGnhz2dWA42rcQRQ5IQGq6xiQ8ykRditC115EA0bDBC-72fFP1EACttFK9nBD6pPEcBZUNk4sJ3Cs2WKLQNBvPcuLXk-0Iogzlf87otX117pSQWycW8yLHm2o4JyQyFPqFR0z1e8Gq6DjMLFJyRu44Qbe6BrRPJa-TG2Wa77N1ePIlJnMsox1GDXcSIZ7WL5PpvmGjI_f1wpbcIAxJO50ITUBXkJNh3gu80AKlAAr8D_AhWIlAkitT3ZrrQriTUnXPeSy9Lo45nSq_rPOQTuBqKNzVrQmDR4=',

  UrlData: {
    //User
    PSSUserListURL: '/user',
    PSSUserUpdateURL: '/user/edit',
    GovEvaUserList: 'structure/(structure-outlet:userMaster/userManagement)',
    GovEvaUserUpdateURL: 'structure/(structure-outlet:userMaster/userManagement)',

    //Director And KMP
    PSSDirectorListURL: '/director/',
    PSSDirectorUpdateURL: '/director/edit',
    PSSKMPListURL: '/KMP',
    PSSKMPUpdateUrl: '/KMP/edit',

    //Roles
    PSSRoleListURL: '/roles',
    PSSRoleUpdateURL: '/roles',
    GovEvaRoleList: '/structure/(structure-outlet:role-master/roleMaster)',
    GovEvaRoleUpdateURL: '/structure/(structure-outlet:role-master/roleMaster)',

    //Company
    PSSCompanyListURL: '/company',
    PSSCompanyUpdateURL: '/company/edit',
    GovEvaCompanyList: '/structure/(structure-outlet:companymaster)',
    GovEvaCompanyUpdateURL: '/structure/(structure-outlet:companymaster)',

    //Company
    PSSFinanceListURL: '/company/financeDetails',
    PSSFinanceUpdateURL: '/company/financeDetails/edit/',

    //Meeting
    PSSMeetingListURL: '/meeting',
    PSSMeetingUpdateURL: '/meeting/edit',

    //Task And Activity
    PSSTagURL: '/group',
    PSSLibraryTaskListURL: '/tasks/library',
    PSSLibraryTaskUpdateURL: '/tasks/library/update',

    PSSActivatedTaskListURL: '/tasks/activated',
    PSSActivatedTaskUpdateURL: '/tasks/activated/update/',

    PSSLibraryProcessListURL: '/process',
    PSSLibraryProcessUpdateURL: '/process/edit',

    PSSActivatedProcessListURL: '/activatedprocess',
    PSSActivatedProcessShowURL: '/process/activatedtasks',

    //Email Template  Reminder
    PSSEmailTemplateURL: '/emailReminderTemplates',

    //Laws & Regulation
    PSSLawsAndRegulationURL: '/compliance',

    //Agenda And Categories
    PSSCategoryURL: '/category',
    PSSAgendaListURL: '/agenda',
    PSSAgendaUpdateURL: '/agenda/edit',

    PSSCommitteeListURL: '/committee',
    PSSCommitteeUpdateURL: '/committee/edit',

    PSSDocumentListURL: '/documentManagement',
    PSSDocumentTypeListURL: '/documentType',

    PSSHolidayListURL: '/holiday',
  },
};

export const PssLink = {
  //Governance
  Reports: 'Reports',
  //Compliance
  Meetings: `${environment.pssUIBaseUrl}meeting`,
  Agenda: `${environment.pssUIBaseUrl}agenda`,
  AgendaSearch: `${environment.pssUIBaseUrl}agendaSearch`,
  Regulation: `${environment.pssUIBaseUrl}regulation`,
  //Report Menu
  ComplianceSnapshot: `${environment.pssUIBaseUrl}complianceSnapshot`,
  TaskStatus: `${environment.pssUIBaseUrl}taskStatus`,
  // Document Management
  Commitee: `${environment.pssUIBaseUrl}committee`,
  Template: `${environment.pssUIBaseUrl}template`,
  KMP: `${environment.pssUIBaseUrl}KMP`,
  Director: `${environment.pssUIBaseUrl}director`,
  CompanyFinancialDetails: `${environment.pssUIBaseUrl}company/financeDetails`,
  AgendaCategories: `${environment.pssUIBaseUrl}category`,
  Documents: `${environment.pssUIBaseUrl}documentManagement`,
  DocumentType: `${environment.pssUIBaseUrl}documentType`,
  EditDirector: `${environment.pssUIBaseUrl}structure/(structure-outlet:director/edit/{userId})`,
  EditKMP: `${environment.pssUIBaseUrl}structure/(structure-outlet:KMP/edit/{userId})`,
  Group: `${environment.pssUIBaseUrl}group`,
  LibraryTaskList: `${environment.pssUIBaseUrl}tasks/library`,
  ActivatedTaskList: `${environment.pssUIBaseUrl}tasks/activated`,
  ProcessList: `${environment.pssUIBaseUrl}process`,
  ActivatedProcessTasks: `${environment.pssUIBaseUrl}activatedprocess`,
  Holiday: `${environment.pssUIBaseUrl}holiday`,
  LawsAndRegulations: `${environment.pssUIBaseUrl}compliance`,
  EmailTemplatesCompliance: `${environment.pssUIBaseUrl}emailReminderTemplates`,
  UPSISharer: `${environment.pssUIBaseUrl}upsisharer`,
  UPSIRecipient: `${environment.pssUIBaseUrl}upsirecipient`,
  UPSIDetails: `${environment.pssUIBaseUrl}upsidetails`,
  UPSIEmailLog: `${environment.pssUIBaseUrl}upsiEmailsLog`,
  UPSIMaster: `${environment.pssUIBaseUrl}upsimaster`,
  UPSIParam: `${environment.pssUIBaseUrl}upsimaster`,
  Templates: `${environment.pssUIBaseUrl}docxTemplates`,
  defaultMeeting: `${environment.pssUIBaseUrl}defaultMeeting`,
  agendaGroup: `${environment.pssUIBaseUrl}agendaGroup`,
  inspectionList: `${environment.pssUIBaseUrl}inspectionList`,
  proxyList: `${environment.pssUIBaseUrl}proxyList`,
  masterbankparticulars: `${environment.pssUIBaseUrl}masterbankparticulars`,
  powerofattorneylist: `${environment.pssUIBaseUrl}powerofattorneylist`,
  paymentOfDividendList: `${environment.pssUIBaseUrl}paymentOfDividendList`,
  investmentlist: `${environment.pssUIBaseUrl}investment-list`,
  ecslist: `${environment.pssUIBaseUrl}ecslist`,
  ben3list: `${environment.pssUIBaseUrl}ben3list`,
  documentundercommonseallist: `${environment.pssUIBaseUrl}documentundercommonseallist`,
  masterinvestorcomplaints: `${environment.pssUIBaseUrl}masterinvestorcomplaints`,
  dividendMandateList: `${environment.pssUIBaseUrl}dividendMandateList`,
  postallballotlist: `${environment.pssUIBaseUrl}postallballotlist`,
  chg7List: `${environment.pssUIBaseUrl}chg7List`,
  mbp2List: `${environment.pssUIBaseUrl}mbp2List`,
  mbp3List: `${environment.pssUIBaseUrl}mbp3List`,
  mbp4List: `${environment.pssUIBaseUrl}mbp4List`,
  mbp4bList: `${environment.pssUIBaseUrl}mbp4bList`,
  mgt1list: `${environment.pssUIBaseUrl}mgt1list`,
  mgt2list: `${environment.pssUIBaseUrl}mgt2-list`,
  sh2list: `${environment.pssUIBaseUrl}sh2-list`,
  sh3list: `${environment.pssUIBaseUrl}sh3-list`,
  mastersh10list: `${environment.pssUIBaseUrl}mastersh10list`,
  mastersh6: `${environment.pssUIBaseUrl}mastersh6`,
  depositorList: `${environment.pssUIBaseUrl}depositorList`,
  NCDDocumentGenerationSetup: `${environment.pssUIBaseUrl}ncd/document/generation/mster/setup`,
  ncdIssuesList: `${environment.pssUIBaseUrl}ncd-issues-List`,
  ncdLibrary: `${environment.pssUIBaseUrl}ncd-Library`,
  ncdAllotteesLibrary: `${environment.pssUIBaseUrl}ncd-allottees-Library`,
  emailReminderTemplatesTask: `${environment.pssUIBaseUrl}emailReminderTemplates/Task`,
  emailReminderTemplatesUpsi: `${environment.pssUIBaseUrl}emailReminderTemplates/Upsi`,
  emailReminderTemplatesNcd: `${environment.pssUIBaseUrl}emailReminderTemplates/Ncd`,
  userTeamMaster: `${environment.pssUIBaseUrl}userTeamMaster`,
  unapprovedLibraryTasks: `${environment.pssUIBaseUrl}tasks/unapprovedLibrary`,
  department: `${environment.pssUIBaseUrl}department`,
  branch: `${environment.pssUIBaseUrl}branch`,
  userteam: `${environment.pssUIBaseUrl}user/team`,
  ComplianceItem: `${environment.pssUIBaseUrl}complianceItem`,
  ComplianceCertificateLibrary: `${environment.pssUIBaseUrl}complianceCertificateList`,
  ActivatedComplianceCertificate: `${environment.pssUIBaseUrl}activatedComplianceCertificate`,
  MeetingEmailTemplates: `${environment.pssUIBaseUrl}emailReminderTemplates/Meeting`,
  ComplianceCertificateEmailTemplates: `${environment.pssUIBaseUrl}emailReminderTemplates/ComplianceCertificate`,
  //Laws & Regulations
  LawRegulation: `${environment.pssUIBaseUrl}compliance`,
};

// // The file contents for the current environment will overwrite these during build.
// // The build system defaults to the dev environment which uses `environment.ts`, but if you do
// // `ng build --env=prod` then `environment.prod.ts` will be used instead.
// // The list of which env maps to which file can be found in `.angular-cli.json`.

// // const BasePATH_GFMRootPath = '/home/ec2-user/GEM/GFM/';
// // const BaseURL_MasterAPI = 'https://test-masterapi.${domain}.com';
// // const BaseURL_GovevaAPI = 'https://ardvark.${domain}.com'; // Client API
// // const BaseURL_PSSAPI = 'https://ardvark.${domain}.com';
// // const BaseURL_PSSUI = 'https://ardvark.${domain}.com';
// // const BaseURL_GEMURL = 'https://ardvark.${domain}.com/gemapi';
// // const BaseURL_PSSFileurl = 'https://ardvark.${domain}.com/complianceapi/';
// // const BaseURL_PSSFileNotValidurl = 'https://ardvark.${domain}.com/complianceapi';
// // const WebexUrl = 'http://localhost:4200/assets/html/test.html';
// // const BaseURL_UIBaseUrl = 'http://localhost:4200';
// // const GovevaApipath = 'govevaapi/api/v1/';



// export const environment = {
//   production: false,
//   envName: 'default',
//   Service: {
//     All: false,
//     PSS: true,
//     GovEva: true,
//     UPSI: true,
//     NCD: true,
//     BoardEvaluation: true,
//     GEM: true,
//     GemWeb: true,
//     Chat: false,
//     Governance: true,
//     RegularMeeting: true,
//     MeetingMakerWithAgenda: false,
//     MeetingMakerWithoutAgenda: false,
//     // GemWeb: false,
//     // Governance: true,
//     // RegularMeeting: false,
//     // MeetingMakerWithAgenda : false,
//     // MeetingMakerWithoutAgenda : false,
//     CompanySetupWithoutMasterApi: false,
//     //Authorisation key check with the master API
//     authorization: 'QmVhcmVyIDcxRDUwRjk5ODc1Mjk=',
//   },

//   // url: `${BaseURL_MasterAPI}/api/v1/secure/`,
//   // clientUrl: `${BaseURL_GovevaAPI}/${GovevaApipath}secure/`,
//   // nonValidateUrl: `${BaseURL_GovevaAPI}/${GovevaApipath}`,
//   // pssServerUrl: `${BaseURL_PSSAPI}/complianceapi/v1/secure/`,
//   // pssUIBaseUrl: `${BaseURL_PSSUI}/compliance/#/`,
//   // pssUIURL: `${BaseURL_PSSUI}/compliance/#/`,
//   // serverIP: BaseURL_GovevaAPI,
//   // GEMURL: `${BaseURL_GEMURL}/api/`,
//   // GFMRootPath: BasePATH_GFMRootPath,
//   // sessionTime: 28800000,
//   // PSSFileurl: BaseURL_PSSFileurl,
//   // PSSFileNotValidurl: `${BaseURL_PSSFileNotValidurl}/api/v1/`,
//   // webexUrl: WebexUrl,
//   // UIBaseUrl: BaseURL_UIBaseUrl,
// };

// export const PssLink = {
//   //Governance
//   Reports: 'Reports',
//   //Compliance
//   // Meetings: environment.pssUIBaseUrl + 'meeting',
//   // Agenda: environment.pssUIBaseUrl + 'agenda',
//   // Regulation: environment.pssUIBaseUrl + 'regulation',
//   // //Report Menu
//   // ComplianceSnapshot: environment.pssUIBaseUrl + 'complianceSnapshot',
//   // TaskStatus: environment.pssUIBaseUrl + 'taskStatus',
//   // // Document Management
//   // Commitee: environment.pssUIBaseUrl + 'committee',
//   // Template: environment.pssUIBaseUrl + 'template',
//   // KMP: environment.pssUIBaseUrl + 'KMP',
//   // Director: environment.pssUIBaseUrl + 'director',
//   // CompanyFinancialDetails: environment.pssUIBaseUrl + 'company/financeDetails',
//   // AgendaCategories: environment.pssUIBaseUrl + 'category',
//   // Documents: environment.pssUIBaseUrl + 'documentManagement',
//   // DocumentType: environment.pssUIBaseUrl + 'documentType',
//   // EditDirector: environment.pssUIBaseUrl + 'director/edit/{userId}',
//   // EditKMP: environment.pssUIBaseUrl + 'KMP/edit/{userId}',
//   // Group: environment.pssUIBaseUrl + 'group',
//   // LibraryTaskList: environment.pssUIBaseUrl + 'tasks/library',
//   // ActivatedTaskList: environment.pssUIBaseUrl + 'tasks/activated',
//   // ProcessList: environment.pssUIBaseUrl + 'process',
//   // ActivatedProcessTasks: environment.pssUIBaseUrl + 'activatedprocess',
//   // Holiday: environment.pssUIBaseUrl + 'holiday',
//   // LawsAndRegulations: environment.pssUIBaseUrl + 'compliance',
//   // EmailTemplatesCompliance: environment.pssUIBaseUrl + 'emailReminderTemplates',
//   // UPSISharer: environment.pssUIBaseUrl + 'upsisharer',
//   // UPSIRecipient: environment.pssUIBaseUrl + 'upsirecipient',
//   // UPSIDetails: environment.pssUIBaseUrl + 'upsidetails',
//   // UPSIEmailLog: environment.pssUIBaseUrl + 'upsiEmailsLog',
//   // UPSIMaster: environment.pssUIBaseUrl + 'upsimaster',
//   // UPSIParam: environment.pssUIBaseUrl + 'upsimaster',
//   // Templates: environment.pssUIBaseUrl + 'docxTemplates',
//   // defaultMeeting: environment.pssUIBaseUrl + 'defaultMeeting',
//   // agendaGroup: environment.pssUIBaseUrl + 'agendaGroup',
//   // inspectionList: environment.pssUIBaseUrl + 'inspectionList',
//   // proxyList: environment.pssUIBaseUrl + 'proxyList',
//   // masterbankparticulars: environment.pssUIBaseUrl + 'masterbankparticulars',
//   // powerofattorneylist: environment.pssUIBaseUrl + 'powerofattorneylist',
//   // paymentOfDividendList: environment.pssUIBaseUrl + 'paymentOfDividendList',
//   // investmentlist: environment.pssUIBaseUrl + 'investment-list',
//   // ecslist: environment.pssUIBaseUrl + 'ecslist',
//   // ben3list: environment.pssUIBaseUrl + 'ben3list',
//   // documentundercommonseallist:
//   //   environment.pssUIBaseUrl + 'documentundercommonseallist',
//   // masterinvestorcomplaints:
//   //   environment.pssUIBaseUrl + 'masterinvestorcomplaints',
//   // dividendMandateList: environment.pssUIBaseUrl + 'dividendMandateList',
//   // postallballotlist: environment.pssUIBaseUrl + 'postallballotlist',
//   // chg7List: environment.pssUIBaseUrl + 'chg7List',
//   // mbp2List: environment.pssUIBaseUrl + 'mbp2List',
//   // mbp3List: environment.pssUIBaseUrl + 'mbp3List',
//   // mbp4List: environment.pssUIBaseUrl + 'mbp4List',
//   // mbp4bList: environment.pssUIBaseUrl + 'mbp4bList',
//   // mgt1list: environment.pssUIBaseUrl + 'mgt1list',
//   // mgt2list: environment.pssUIBaseUrl + 'mgt2-list',
//   // sh2list: environment.pssUIBaseUrl + 'sh2-list',
//   // sh3list: environment.pssUIBaseUrl + 'sh3-list',
//   // mastersh10list: environment.pssUIBaseUrl + 'mastersh10list',
//   // mastersh6: environment.pssUIBaseUrl + 'mastersh6',
//   // depositorList: environment.pssUIBaseUrl + 'depositorList',
//   // NCDDocumentGenerationSetup:
//   //   environment.pssUIBaseUrl + 'ncd/document/generation/mster/setup',
//   // ncdIssuesList: environment.pssUIBaseUrl + 'ncd-issues-List',
//   // ncdLibrary: environment.pssUIBaseUrl + 'ncd-Library',
//   // ncdAllotteesLibrary: environment.pssUIBaseUrl + 'ncd-allottees-Library',
//   // emailReminderTemplatesTask:
//   //   environment.pssUIBaseUrl + 'emailReminderTemplates/Task',
//   // emailReminderTemplatesUpsi:
//   //   environment.pssUIBaseUrl + 'emailReminderTemplates/Upsi',
//   // emailReminderTemplatesNcd:
//   //   environment.pssUIBaseUrl + 'emailReminderTemplates/Ncd',
//   // userTeamMaster: environment.pssUIBaseUrl + 'userTeamMaster',
//   // unapprovedLibraryTasks: environment.pssUIBaseUrl + 'tasks/unapprovedLibrary',
//   // department: environment.pssUIBaseUrl + 'department',
//   // branch: environment.pssUIBaseUrl + 'branch',
//   // userteam: environment.pssUIBaseUrl + 'user/team',
//   // ComplianceItem: environment.pssUIBaseUrl + 'complianceItem',
//   // ComplianceCertificateLibrary:
//   //   environment.pssUIBaseUrl + 'complianceCertificateList',
//   // ActivatedComplianceCertificate:
//   //   environment.pssUIBaseUrl + 'activatedComplianceCertificate',
//   // MeetingEmailTemplates:
//   //   environment.pssUIBaseUrl + 'emailReminderTemplates/Meeting',
//   // ComplianceCertificateEmailTemplates:
//   //   environment.pssUIBaseUrl + 'emailReminderTemplates/ComplianceCertificate',
// };
